import { Box } from '@mui/material';

/**
 * 区切り線で囲ったボタン列（サンプル route-planner MatchingPresenter/index.tsx:1399-1485）。
 * 押されているものだけ主色で塗り、他は枠だけ残す。
 *
 * 表示項目の Popover に置く設定セクションが共通で使う。幅 320 の Popover に収める前提で、
 * 入りきらない選択肢は折り返す（横スクロールにすると隠れた選択肢に気づけない）。
 */
const SegmentedButtons = <T extends string>({ options, value, height, onChange }: {
  options: readonly (readonly [T, string])[];
  value: T;
  height: number;
  onChange: (next: T) => void;
}) => (
  <Box
    sx={{
      display: 'inline-flex',
      border: '1px solid hsl(var(--border))',
      borderRadius: 1,
      overflow: 'hidden',
      flexWrap: 'wrap',
    }}
  >
    {options.map(([option, label]) => {
      const active = value === option;
      return (
        <Box
          key={option}
          component="button"
          type="button"
          aria-pressed={active}
          onClick={() => onChange(option)}
          sx={{
            px: 1.25,
            height,
            fontSize: height >= 24 ? 11 : 10,
            fontWeight: active ? 700 : 500,
            bgcolor: active ? 'hsl(var(--primary) / 0.12)' : 'transparent',
            color: active ? 'primary.main' : 'text.secondary',
            border: 'none',
            cursor: 'pointer',
            '&:hover': active ? {} : { bgcolor: 'action.hover' },
          }}
        >
          {label}
        </Box>
      );
    })}
  </Box>
);

/** 表示項目の Popover のセクション見出し（数値指標・表示情報と同じ字面に揃える） */
export const popoverSectionLabelSx = {
  fontSize: 10,
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: '0.08em',
  color: 'text.secondary',
} as const;

export default SegmentedButtons;
